import {
  FullscreenButton,
  Gesture,
  PlayButton,
  useMediaState,
} from "@vidstack/react";
import { useEffect } from "react";
import { LuExpand, LuPause, LuPlay, LuShrink } from "react-icons/lu";

import { InfoTooltip } from "@/components/shared/info-tooltip";
import { Spinner } from "@/components/shared/spinner";
import { Button } from "@/components/ui/button";

type MediaControlIntentProps = {
  onUserMediaIntent?: () => void;
};

const controlButtonClassName = `
  relative z-1 text-xl text-muted-foreground
  hover:text-primary
`;

export function Play({ onUserMediaIntent }: MediaControlIntentProps) {
  const isPaused = useMediaState("paused");
  const isWaiting = useMediaState("waiting");

  return (
    <InfoTooltip
      text={!isPaused ? "Pause" : "Play"}
      className="
        hidden
        md:block
      "
    >
      <PlayButton asChild>
        <Button
          tabIndex={1}
          className={controlButtonClassName}
          onClick={onUserMediaIntent}
          variant="ghost"
        >
          {!isPaused ? <LuPause /> : <LuPlay className="relative left-px" />}
          {isWaiting && (
            <div className="absolute inset-0 flex items-center justify-center">
              <Spinner size={32} />
            </div>
          )}
        </Button>
      </PlayButton>
    </InfoTooltip>
  );
}

export function Fullscreen({ onUserMediaIntent }: MediaControlIntentProps) {
  const isActive = useMediaState("fullscreen");

  useEffect(() => {
    if (isActive) {
      document.body.style.pointerEvents = "none";
    } else {
      setTimeout(() => {
        document.body.style.pointerEvents = "all";
      }, 500);
    }
  }, [isActive]);

  return (
    <InfoTooltip
      text={!isActive ? "Fullscreen" : "Exit Fullscreen"}
      className="
        hidden
        md:block
      "
    >
      <FullscreenButton asChild>
        <Button
          className={`${controlButtonClassName} p-0`}
          onClick={onUserMediaIntent}
          variant="ghost"
        >
          {!isActive ? <LuExpand /> : <LuShrink />}
        </Button>
      </FullscreenButton>
    </InfoTooltip>
  );
}

export function Gestures({ onUserMediaIntent }: MediaControlIntentProps) {
  return (
    <>
      <Gesture
        className="absolute inset-0 z-0 block size-full"
        event="click"
        action="toggle:paused"
        onTrigger={onUserMediaIntent}
      />
      <Gesture
        className="absolute inset-0 z-0 block size-full"
        event="dblclick"
        action="toggle:fullscreen"
        onTrigger={onUserMediaIntent}
      />
      {/* <Gesture
        className="absolute left-0 top-0 z-10 block h-full w-1/5"
        event="dblpointerup"
        action="seek:-10"
      />
      <Gesture
        className="absolute right-0 top-0 z-10 block h-full w-1/5"
        event="dblpointerup"
        action="seek:10"
      />*/}
    </>
  );
}
